import Vue from "vue";//引入vue
import VueRouter from "vue-router";//引入vue路由
 
import dengLu from "@/components/Denglu/dengLu.vue";//登录
import Home from "@/components/home/index.vue";//首页
import Sucai from "@/components/home/sucai.vue";//音乐
import Manhua from "@/components/home/manhua.vue";//漫画
import Xiangqing from "@/components/home/ManQing/xingqingM.vue";//详情页
import Browse from "@/components/home/ManQing/browse.vue";//浏览漫画
import Chongzhi from "@/components/home/Chongzhi.vue";//充值
import Heji from "@/components/home/Heji.vue";//精选和合集
import Personal from "@/components/home/geren/personal.vue";//个人页
import Yh_shuang from "@/components/xieyi/yh_shuang.vue";//用户协议
import Ys_shuang from "@/components/xieyi/ys_shuang.vue";//隐私政策
import Wcnr from "@/components/xieyi/wcnr.vue";//未成年人保护
import Cz_shuang from "@/components/xieyi/cz_shuang.vue";//充值协议
import Wangji from "@/components/Denglu/wj.vue";
Vue.use(VueRouter);//挂在路由插件
const routes = [//路由表示的是url和组件的一一对应的关系，使用path属性表示url路径，使用component属性表示组件
    
    {
        name:'Nhome',//Home
        path:'/',
        component:Home,
    },
    {
        name:'Nczxy',//充值协议
        path:'/czxy',
        component:Cz_shuang,
    },
    {
        name:'Nwj',//充值协议
        path:'/wj',
        component:Wangji,
    },
    {
        name:'Nminor',//未成年人
        path:'/minor',
        component:Wcnr,
    },
    {
        name:'Nyszc',//隐私政策
        path:'/PrivacyPolicy',
        component:Ys_shuang,
    },
    {
        name:'Nyhxy',//用户协议
        path:'/UserAgreement',
        component:Yh_shuang,
    },
    {
        name:'login',//登录
        path:'/login',
        component:dengLu,
    },
    {
        name:'Nsucai',//音乐
        path:'/sucai',
        component:Sucai,
    },
    {
        name:'Nmanhua',//漫画
        path:'/manhua',
        component:Manhua,
    },
        {
        name:'Nxiangqing',//详情
        path:'/xiangqing/:name',
        component:Xiangqing,
    },
    {
        name:'Nbrowse',//浏览漫画
        path:'/browse/:Mid/:Hid',
        component:Browse,
    },
    {
        name:'Nchongzhi',//充值
        path:'/topUp',
        component:Chongzhi,
    },
    {
        name:'Nheji',//合集
        path:'/collection',
        component:Heji,
    },
    {
        name:'Npersonal',//个人页
        path:'/personal',
        component:Personal,
    }
]
const router = new VueRouter({// 生成一个路由实例
    routes,// 配置项-配置视图和路由之间的对应关系
    scrollBehavior() {
    // 始终滚动到顶部
    return { x: 0, y: 0 };
  }
});
//修改原型对联 的push 
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
//导航守卫
// router.beforeEach((to,from,next)=>{
//     console.log(to,from)
//     next();
// })
 
export default router // 导出路由实例